import Controller from "csi/action/Controller";
import localeProvider from "csi/page/localeProvider";
import declare from "dojo/_base/declare";
import { createRestoreFromThemeStore } from "./RestoreFromBOMService";
import { RestoreFromBOMResources } from "./RestoreFromBOMStore";

const RestoreFromThemeController = declare(Controller, {
	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache, m_formData, m_action } = this;
		const resource : RestoreFromBOMResources = {
			configureRestoreSettings: "ConfigureRestoreSettings",
			restoreSettings: "RestoreSettings",
			placementsToDelete: "PlacementsToDelete",
			placementsOnStyleBOM: "PlacementsOnStyleBOM",
			placementsToAdd: "PlacementsToAdd",
		};
		props.store = await createRestoreFromThemeStore(m_action.getId(), m_cache, m_formData, this.getParent(), props.onClose, props.onSave, localeProvider, resource);
	},
});

export = RestoreFromThemeController;